import { FloraButton } from '@grupoboticario/flora-react';
import { Picture } from 'ui/components/primitives';
import { theme, styled, mixins } from 'ui/theme';

export const DeleteItem = {
  Name: styled('span')`
    ${mixins.overline};
  `,

  Product: styled.div`
    align-items: center;
    display: flex;
  `,

  Picture: styled(Picture)`
    max-width: ${theme.space[12]};
    margin-right: ${theme.space[4]};

    img {
      background: ${theme.colors.build.lightLight};
      border-radius: ${theme.radii.small};
      padding: ${theme.space[1]};
    }
  `,

  Title: styled.div`
    ${mixins.bodyLargeStandard};
    width: 90%;
  `,

  CancelButton: styled(FloraButton)`
    color: ${theme.colors.action.navigation.standard.static};
    border-color: ${theme.colors.action.navigation.standard.static};
  `,
};
